import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate, Button } from '@haldor/ui';
import { connect } from 'react-redux';
import { Spinner } from 'UI';
import '../_onboarding.scss';
import moment from 'moment';
import getEnvironment from 'lib/env';

var WaitingForResponse = /*#__PURE__*/function (_Component) {
  _inherits(WaitingForResponse, _Component);

  var _super = _createSuper(WaitingForResponse);

  function WaitingForResponse(props) {
    var _this;

    _classCallCheck(this, WaitingForResponse);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "goBack", function () {
      return new Promise(function (resolve) {
        if (_this.props.onSubmit) {
          _this.props.onSubmit(0).then(function () {
            resolve(1);
          });
        }
      });
    });

    _this.state = {
      recentSentMailDate: null
    };
    return _this;
  }

  _createClass(WaitingForResponse, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.adminInvitations != null) {
        var date = moment.utc(this.props.adminInvitations.latestSentDate);
        var stringDate = date.local().format('YYYY-MM-DD LTS');
        this.setState({
          recentSentMailDate: stringDate
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var product = getEnvironment().id;
      var productName = 'Haldor Education';

      if (product === 'haldor_planning') {
        productName = "Haldor Planning";
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
        style: {
          textAlign: 'left'
        }
      }, this.props.translate('Great to see you!')), /*#__PURE__*/React.createElement("p", {
        style: {
          textAlign: 'left',
          marginTop: '1rem',
          marginBottom: '1rem'
        }
      }, this.props.translate('We are waiting for an Office 365 administrator in your organisation to approve {0}. You will not be able to use the services until that is done. An e-mail requesting approval was sent to your administrator on').replace('{0}', productName), " ", this.state.recentSentMailDate, ". "), /*#__PURE__*/React.createElement("p", {
        style: {
          textAlign: 'left',
          marginTop: '1rem',
          marginBottom: '1rem'
        }
      }, this.props.translate('Would you like to send a new e-mail to remind your administrator?')), /*#__PURE__*/React.createElement("div", {
        style: {
          width: '20rem',
          marginBottom: '2rem'
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: "/dist/svg/illustration_vantar_pa_godkannande.svg"
      }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
        type: "primary",
        style: {
          marginRight: '0.5rem'
        },
        onClick: function onClick() {
          _this2.props.showPage('showEmailInfo');
        }
      }, this.props.translate('Open e-mail suggestion'), " "), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginRight: '0.5rem'
        },
        onClick: function onClick() {
          _this2.props.showPage('navigateToAdminConsent');
        }
      }, this.props.translate('I am an Office 365-admin'), " "), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.props.goBack
      }, this.props.translate('Back'), " ")));
    }
  }]);

  return WaitingForResponse;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    adminInvitations: state.Services.adminInvitations
  };
}

export default connect(mapStateToProps, {})(WaitingForResponse);